export default __webpack_public_path__ + "static/media/grb-srbija.ce4955d4.jpg";